module.exports = __webpack_public_path__ + "img/icon-sad.cb70a6ea.svg";